import { ArrowRight } from "lucide-react"
import { contactPath } from "~/common/paths"
import { sections } from "~/content/sections"
import { trackCtaClick } from "~/lib/analytics"
import { NewsletterForm } from "~/marketing/lead-forms"
import { LinkButton } from "~/ui/link-button"

export const SectionHeading = ({
  eyebrow,
  heading,
  body,
  tone = "default",
}: {
  eyebrow?: string
  heading: string
  body: string
  tone?: "default" | "inverse" | "primary"
}) => {
  const bodyClassName =
    tone === "primary"
      ? "text-primary-foreground"
      : tone === "inverse"
        ? "text-secondary-foreground/75"
        : "text-muted-foreground"
  const eyebrowClassName = tone === "primary" ? "text-primary-foreground" : "marketing-orange-text"

  return (
    <div className="max-w-3xl">
      {eyebrow && <p className={`marketing-eyebrow ${eyebrowClassName}`}>{eyebrow}</p>}
      <h2 className="marketing-section-heading mt-4">{heading}</h2>
      <p className={`mt-5 text-lg leading-relaxed ${bodyClassName}`}>{body}</p>
    </div>
  )
}

export const ContactCta = () => {
  const section = sections["contact-cta"]

  return (
    <section className="marketing-surface-primary marketing-section bg-primary text-primary-foreground">
      <div className="container grid gap-8 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-end">
        <SectionHeading {...section} eyebrow="Start a conversation" tone="primary" />
        <LinkButton
          to={contactPath({})}
          onClick={() => trackCtaClick("Get in touch", "section", contactPath({}))}
          size="lg"
          className="bg-background text-foreground hover:bg-background/90"
        >
          Get in touch <ArrowRight />
        </LinkButton>
      </div>
    </section>
  )
}

export const NewsletterCta = () => {
  const section = sections.newsletter

  return (
    <section className="marketing-surface-primary marketing-section bg-primary text-primary-foreground">
      <div className="container text-center">
        <div className="mx-auto max-w-5xl [&>p]:text-primary-foreground">
          <SectionHeading {...section} tone="primary" />
        </div>
        <div className="mx-auto mt-8 max-w-md text-left [&_form]:mx-auto [&_input]:border [&_input]:border-primary-foreground/35 [&_input]:focus-visible:ring-secondary [&_input]:focus-visible:ring-offset-primary [&_label]:text-primary-foreground [&_button]:w-full [&_button]:bg-secondary [&_button]:text-secondary-foreground [&_button]:hover:bg-secondary/90">
          <NewsletterForm placement="newsletter-section" />
        </div>
      </div>
    </section>
  )
}
